
import { SiriusBaseComponent } from 'sirius-framework';
import { Component, OnDestroy, ViewChild } from '@angular/core';
import { AccountService } from '../../inner-menu-account.service';
import { MemberInfo, SharedModel } from '../../../shared/models/shared.model';
import { MessageShowComponent } from '../../../popup/message-show/message-show.component';
import { CommonService } from '../../../shared/service/shared.service';
import { SiteLanguageService } from '../../../shared/service/site-language.service';
import { Subscription } from 'rxjs';

/** String resource — boşsa Türkçe varsayılan */
const PROFILE_KEYS = {
    pageTitle: 'yediEminProfilePageTitle',
    labelIdentity: 'labelIdentityyediEminProfileLabelIdentity',
    labelBirthDate: 'labelBirthDateyediEminProfileLabelBirthDate',
    placeholderBirthDate: 'placeholderBirthDateyediEminProfilePlaceholderBirthDate',
    labelFirstName: 'labelFirstNameyediEminProfileLabelFirstName',
    labelLastName: 'labelLastNameyediEminProfileLabelLastName',
    btnUpdate: 'btnUpdateyediEminProfileBtnUpdate',
    labelMobilePhone: 'labelMobilePhoneyediEminProfileLabelMobilePhone',
    labelEmail: 'labelEmailyediEminProfileLabelEmail',
    placeholderEmailOptional: 'yediEminProfilePlaceholderEmailOptional',
    emailValidationMessage: 'yediEminProfileEmailValidationMessage',
    popupTitle: 'yediEminProfilePopupTitle',
    msgNameMismatch: 'yediEminProfileMsgNameMismatch',
    msgPhoneSameAsCurrent: 'yediEminProfileMsgPhoneSameAsCurrent', 
    msgPhoneUpdateConfirm: 'yediEminProfileMsgPhoneUpdateConfirm',
    msgBirthDateRequired: 'yediEminProfileMsgBirthDateRequired',
};

/** Kaynak eksikse kullanılacak sabit Türkçe varsayılanlar. Dil değişiminde
 *  bileşen alanı fallback olarak verilirse bir önceki dildeki metin kalıcı
 *  olabildiği için sabit tutulur. */
const PROFILE_DEFAULTS = {
    pageTitle: 'Kullanıcı Bilgileri',
    labelIdentity: 'Kimlik No',
    labelBirthDate: 'Doğum Tarihi',
    placeholderBirthDate: 'GG-AA-YYYY',
    labelFirstName: 'Adı',
    labelLastName: 'Soyadı',
    btnUpdate: 'Güncelle',
    labelMobilePhone: 'Cep Telefonu Numarası',
    labelEmail: 'Email',
    placeholderEmailOptional: 'opsiyonel',
    emailValidationMessage: 'Lütfen girdiğiniz e-posta adresini kontrol ediniz.',
    popupTitle: 'Uyarı',
    msgNameMismatch: 'Sistemimizde ad soyad bilginizde bir hata tespit ettik. Lütfen doğum tarihinizi girip  Güncelle butonunu tıklayınız. Bu işlemi tamamladıktan sonra satıcı veya alıcı olarak kayıt işlemlerinize devam edebilirsiniz.',
    msgPhoneSameAsCurrent: 'Lütfen güncellemek istediğiniz telefon numarasını giriniz.',
    msgPhoneUpdateConfirm: 'Mevcut telefon numaranızı güncellemek için  ve [PHONE] numaralı telefona doğrulama kodu gönderilecektir. Devam etmek istiyor musunuz?',
    msgBirthDateRequired: 'Lütfen doğum tarihinizi giriniz.',
};

@Component({
    selector: 'profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css']
})
export class ProfileComponent extends SiriusBaseComponent<any> implements OnDestroy {

    @ViewChild('messagePopup') messagePopup: MessageShowComponent;
    @ViewChild('BirthdateBox') birthdateBox: any;
    private profileInfo: MemberInfo = null;
    private maskTel = ['(', /[5]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
    public maskDate = SharedModel.dTarihiMask;
    private isSubmitted: boolean = false;
    private popUpMessage: string;
    popUpTitle = PROFILE_DEFAULTS.popupTitle;
    private isPhoneButtonClicked: boolean = false;
    currentPhone: string;
    isBirthDayActive: boolean = false;

    pageTitle = PROFILE_DEFAULTS.pageTitle;
    labelIdentity = PROFILE_DEFAULTS.labelIdentity;
    labelBirthDate = PROFILE_DEFAULTS.labelBirthDate;
    placeholderBirthDate = PROFILE_DEFAULTS.placeholderBirthDate;
    labelFirstName = PROFILE_DEFAULTS.labelFirstName;
    labelLastName = PROFILE_DEFAULTS.labelLastName;
    btnUpdate = PROFILE_DEFAULTS.btnUpdate;
    labelMobilePhone = PROFILE_DEFAULTS.labelMobilePhone;
    labelEmail = PROFILE_DEFAULTS.labelEmail;
    placeholderEmailOptional = PROFILE_DEFAULTS.placeholderEmailOptional;
    emailValidationMessage = PROFILE_DEFAULTS.emailValidationMessage;

    msgNameMismatch = PROFILE_DEFAULTS.msgNameMismatch;
    msgPhoneSameAsCurrent = PROFILE_DEFAULTS.msgPhoneSameAsCurrent;
    msgPhoneUpdateConfirm = PROFILE_DEFAULTS.msgPhoneUpdateConfirm;
    msgBirthDateRequired = PROFILE_DEFAULTS.msgBirthDateRequired;

    private langSub: Subscription;

    constructor(
        private accountService: AccountService,
        private commonService: CommonService,
        private siteLanguage: SiteLanguageService) {
        super();
    }
    OnInit() {
        this.accountService.dataServiceInstance = this.dataService;
        this.langSub = this.siteLanguage.languageCode$.subscribe(() => this.loadProfileResourceStrings());
        this.getMemberInfo();
        const birthDayActiveValue = this.commonService.getStringResource('askbirthday', '');
        if (birthDayActiveValue === '1') {
            this.isBirthDayActive = true;
        }
    }

    private loadProfileResourceStrings(): void {
        const r = (key: string, fallback: string) => this.commonService.getStringResource(key, fallback);
        this.pageTitle = r(PROFILE_KEYS.pageTitle, PROFILE_DEFAULTS.pageTitle);
        this.labelIdentity = r(PROFILE_KEYS.labelIdentity, PROFILE_DEFAULTS.labelIdentity);
        this.labelBirthDate = r(PROFILE_KEYS.labelBirthDate, PROFILE_DEFAULTS.labelBirthDate);
        this.placeholderBirthDate = r(PROFILE_KEYS.placeholderBirthDate, PROFILE_DEFAULTS.placeholderBirthDate);
        this.labelFirstName = r(PROFILE_KEYS.labelFirstName, PROFILE_DEFAULTS.labelFirstName);
        this.labelLastName = r(PROFILE_KEYS.labelLastName, PROFILE_DEFAULTS.labelLastName);
        this.btnUpdate = r(PROFILE_KEYS.btnUpdate, PROFILE_DEFAULTS.btnUpdate);
        this.labelMobilePhone = r(PROFILE_KEYS.labelMobilePhone, PROFILE_DEFAULTS.labelMobilePhone);
        this.labelEmail = r(PROFILE_KEYS.labelEmail, PROFILE_DEFAULTS.labelEmail);
        this.placeholderEmailOptional = r(PROFILE_KEYS.placeholderEmailOptional, PROFILE_DEFAULTS.placeholderEmailOptional);
        this.emailValidationMessage = r(PROFILE_KEYS.emailValidationMessage, PROFILE_DEFAULTS.emailValidationMessage);
        this.popUpTitle = r(PROFILE_KEYS.popupTitle, PROFILE_DEFAULTS.popupTitle);
        this.msgNameMismatch = r(PROFILE_KEYS.msgNameMismatch, PROFILE_DEFAULTS.msgNameMismatch);
        this.msgPhoneSameAsCurrent = r(PROFILE_KEYS.msgPhoneSameAsCurrent, PROFILE_DEFAULTS.msgPhoneSameAsCurrent);
        this.msgPhoneUpdateConfirm = r(PROFILE_KEYS.msgPhoneUpdateConfirm, PROFILE_DEFAULTS.msgPhoneUpdateConfirm);
        this.msgBirthDateRequired = r(PROFILE_KEYS.msgBirthDateRequired, PROFILE_DEFAULTS.msgBirthDateRequired);
    }

    ngOnDestroy() {
        if (this.langSub) {
            this.langSub.unsubscribe();
        }
    }

  private getMemberInfo() {
    const response = this.accountService.getCustomerInfo().toPromise();
    response.then((result) => {
      let name = '';
      let surname = '';
      if (this.profileInfo != null) {
        name = this.profileInfo.Name;
        surname = this.profileInfo.Surname;
      }
      this.profileInfo = <MemberInfo>result;
      this.currentPhone = this.profileInfo.PhoneNumber;
      if ((name !== '' && name !== this.profileInfo.Name) || (surname !== '' && surname !== this.profileInfo.Surname)) {
        this.commonService.loggedUserName.next(this.profileInfo.Name + ' ' + this.profileInfo.Surname);
      }

      if (this.profileInfo.GetName) {
        this.popUpMessage = this.msgNameMismatch;
        this.messagePopup.showCancelButton = false;
        this.messagePopup.showPopup();
      }
    });
  }

    private updatePhone(e: any) {

        if (this.currentPhone === this.profileInfo.PhoneNumber.replace(/"/g, '').replace(/'/g, '').replace(/\(|\)/g, '').replace(/-/g, '')) {
            this.popUpMessage = this.msgPhoneSameAsCurrent;
            this.messagePopup.showCancelButton = false;
            this.messagePopup.showPopup();
            return;
        }
        else {
            this.isPhoneButtonClicked = true;
            this.popUpMessage = this.commonService.prepareStringText(this.msgPhoneUpdateConfirm, [
                { key: 'PHONE', value: this.profileInfo.PhoneNumber }
            ]);
            this.messagePopup.showPopup();
            this.messagePopup.showCancelButton = true;
        }
        e.preventDefault();
    }

    private updateEmail(e: any) {
        this.isPhoneButtonClicked = false;
        this.updateCustomerInfo('E');
        e.preventDefault();
    }

  private updateName(e: any) {
    this.isPhoneButtonClicked = false;
    let isValidDate = false;
    if (this.isBirthDayActive) {
      this.profileInfo.BirthDate = this.birthdateBox.nativeElement.value;
      const dateParts = this.profileInfo.BirthDate.split('/');
      const d = new Date(+dateParts[2], Number(dateParts[1]) - 1, +dateParts[0]);
      isValidDate = this.profileInfo.BirthDate != null && this.profileInfo.BirthDate !== '' && d.toString() !== 'Invalid Date' && d instanceof Date;
    }
    else {
      isValidDate = true;
      this.profileInfo.BirthDate = '01/01/2000';
    }
    if (!isValidDate) {
      this.popUpMessage = this.msgBirthDateRequired;
      this.messagePopup.showCancelButton = false;
      this.messagePopup.showPopup();
      return;
    }
    this.updateCustomerInfo('P');
    this.getMemberInfo();
    e.preventDefault();
  }

    private updateCustomerInfo(updateType: string) {
      this.profileInfo.UpdatedFieldInfo = updateType;
      const promise = this.accountService.updateCustomerInfo(this.profileInfo).toPromise();
        promise.then((result) => {
            this.messagePopup.showCancelButton = false;
            this.popUpMessage = result;
            this.messagePopup.showPopup();
        });
    }

    private onMessageAccepted() {
        if (this.isPhoneButtonClicked) {
            this.isPhoneButtonClicked = false;
            const promise = this.accountService.updatePhoneNumber(this.profileInfo).toPromise();
            promise.then((result) => {
                if (result === 'OK') {
                    this.commonService.logOutClient();
                } else {
                    this.messagePopup.showCancelButton = false;
                    this.popUpMessage = result;
                    this.messagePopup.showPopup();
                }
            });
        }
    }
}
